var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.821 16.1211C17.58 16.8031 16.622 17.3682 15.858 17.5332C15.335 17.6432 14.653 17.7318 12.355 16.7788C9.77399 15.7098 6.19 11.9012 6.19 9.3662C6.19 8.07621 6.934 6.57324 8.235 6.57324C8.86099 6.57324 8.999 6.58507 9.205 7.08007C9.446 7.66207 10.034 9.09616 10.104 9.24316C10.393 9.84616 9.80999 10.1991 9.38699 10.7251C9.25199 10.8831 9.099 11.0541 9.27 11.3481C9.44 11.6361 10.028 12.5938 10.892 13.3628C12.008 14.3578 12.913 14.675 13.237 14.81C13.478 14.91 13.766 14.8872 13.942 14.6992C14.165 14.4582 14.442 14.0581 14.724 13.6641C14.923 13.3811 15.176 13.3458 15.441 13.4458C15.62 13.5078 17.895 14.5649 17.991 14.7339C18.062 14.8569 18.062 15.4391 17.821 16.1211ZM12.002 2H11.997C6.48399 2 2 6.485 2 12C2 14.187 2.70501 16.2149 3.90401 17.8598L2.658 21.5771L6.501 20.3481C8.13172 21.429 10.0456 22.0036 12.002 22C17.515 22 22 17.515 22 12C22 6.485 17.515 2 12.002 2Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.41a09dbf30a41d6e1fd1c7dec242c90a.svg";
export { ForwardRef as ReactComponent };